export default __webpack_public_path__ + "static/media/Frame.f79c95d0.png";